import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46db1b64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "advanced-container" }
const _hoisted_2 = { class: "main-label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider mb-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "advanced-val-con"
}
const _hoisted_5 = { class: "advanced-label" }
const _hoisted_6 = { class: "advanced-value" }
const _hoisted_7 = {
  key: 0,
  class: "advanced-sub-value"
}
const _hoisted_8 = {
  key: 1,
  class: "advanced-val-con"
}
const _hoisted_9 = { class: "advanced-label" }
const _hoisted_10 = { class: "advanced-value" }
const _hoisted_11 = {
  key: 2,
  class: "advanced-action-con"
}
const _hoisted_12 = { class: "advanced-action-desc" }
const _hoisted_13 = { class: "col-span-6" }
const _hoisted_14 = {
  key: 3,
  class: "advanced-val-con mt-2"
}
const _hoisted_15 = { class: "advanced-label" }
const _hoisted_16 = { class: "advanced-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('advanced_vault_operations')) + " ", 1),
    _hoisted_3,
    (_ctx.farmVault.vault?.stats.value.borrowLimit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('borrow_limit')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.fwp(_ctx.farmVault.vault?.stats.value.borrowLimit?.muln(100), 2)) + "% ", 1),
            (_ctx.farmVault.vault?.stats.value.targetBorrowLimit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createTextVNode(" ("),
                  (_ctx.farmVault.vault?.stats.value.idealBorrowLimit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.fwp(_ctx.farmVault.vault?.stats.value.idealBorrowLimit?.muln(100), 2)) + "%/", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(_ctx.fwp(_ctx.farmVault.vault?.stats.value.targetBorrowLimit?.muln(100), 2)) + "%±1%)", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.farmVault.vault?.stats.value.lastHarvestedAt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('last_compound')) + ":", 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getDateFromTimestamp(_ctx.farmVault.vault?.stats.value.lastHarvestedAt)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.account)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('advanced_action_desc')) + ":", 1),
          _createElementVNode("div", _hoisted_13, [
            (
            _ctx.farmVault.vault?.showBorrowLimit ||
            (_ctx.userNetworkConfig.chainId !== 56 &&
              _ctx.userNetworkConfig.chainId !== 250)
          )
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  rounded: "",
                  color: "amber",
                  size: "sm",
                  class: "w-full mb-2",
                  onClick: _ctx.rebalanceVault,
                  loading: _ctx.isRebalancing,
                  loadingLabel: _ctx.$t('rebalancing')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('trigger_rebalance')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "loadingLabel"]))
              : _createCommentVNode("", true),
            _createVNode(_component_BalBtn, {
              rounded: "",
              color: "amber",
              size: "sm",
              class: "w-full",
              onClick: _ctx.harvestVault,
              loading: _ctx.isHarvesting,
              loadingLabel: _ctx.$t('harvesting')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('compound_vault')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading", "loadingLabel"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.farmVault.vault?.stats.value.harvestReward)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('worker_reward')), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(parseFloat(_ctx.fw(_ctx.farmVault.vault.stats.value.harvestReward)).toPrecision(
            4
          )) + " " + _toDisplayString(_ctx.farmVault.vault.harvesterRewardSymbol ||
          _ctx.farmVault.vault.rewardTokenSymbol ||
          _ctx.farmVault.vault.tokenSymbol), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}